import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var featuredStores = new Swiper('[data-carousel="featuredStores"]', {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 'auto',
  centeredSlides: true,
});

var latestListing = new Swiper('[data-carousel="latestListing"]', {
  loop: true,
  loopAdditionalSlides: 5,
  loopedSlides: 5,
  spaceBetween: 25,
  slidesPerView: 'auto',
  initialSlide: 1,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      loop: true,
      loopAdditionalSlides: 4,
      loopedSlides: 4,
      centeredSlides: false,
      spaceBetween: 0,
      initialSlide: 0,
    },
  },
  centeredSlides: true,
});

var latestFeed = new Swiper('[data-carousel="latestFeed"]', {
  loop: true,
  spaceBetween: 25,
  slidesPerView: 'auto',
  initialSlide: 1,
  breakpoints: {
    768: {
      spaceBetween: 100,
      initialSlide: 0,
    },
  },
  centeredSlides: true,
});

var imageGallery = new Swiper('[data-carousel="imageGallery"]', {
  loop: true,
  spaceBetween: 25,
  slidesPerView: 1.25,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 'auto',
    },
  },
  navigation: {
    nextEl: '.imageGallery-next',
    prevEl: '.imageGallery-prev',
  },
});